"use client";

import { useTheme } from "next-themes@0.4.6";
import { Toaster as Sonner, ToasterProps } from "sonner@2.0.3";
import { useLanguage } from "@/contexts/AppContext";
import { a11yTranslations } from "@/i18n/a11y";

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const { locale } = useLanguage();
  const a11y = a11yTranslations[locale];

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      // 구 Toast.tsx 의 15-로케일 닫기 aria-label(closeNotification) 을 sonner 닫기 버튼에 재사용.
      // caller(AppModals)의 toastOptions(style 등)는 병합하되, 지역화 closeButtonAriaLabel 은
      // 래퍼가 최종 적용해 항상 보장(spread 를 앞에 둠 — codex: caller override 로 지역화 무력화 방지).
      toastOptions={{ ...toastOptions, closeButtonAriaLabel: a11y.closeNotification }}
      {...props}
    />
  );
};

export { Toaster };
